import { isServer } from '~/utils/host';

declare global {
  interface Window {
    suppressDoubleTealiumEvent?: boolean;
  }
}

const DELAY = 300;
const ATTEMPTS = 5;

const delay = (ms: number) => new Promise((r) => setTimeout(r, ms));

const handleChat = async (
  e?: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>,
) => {
  e?.preventDefault();
  if (isServer) {
    return;
  }

  for (let attempt = 0; attempt < ATTEMPTS; attempt++) {
    const button = document.querySelector('#customChatButton');
    if (button) {
      try {
        window.suppressDoubleTealiumEvent = true;
        button.dispatchEvent(new Event('click', { bubbles: true }));
      } finally {
        setTimeout(() => {
          window.suppressDoubleTealiumEvent = false;
        }, 5000);
      }
      return;
    }
    await delay(DELAY);
  }

  console.warn('[Chat] Timed out trying to open chat');
};

export default handleChat;
